/*=============================================== Main ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled from "styled-components";
import Variables from "./Variables";
import Mixins from "./Mixins";
/*==================== Component ====================*/
var Main = function (_a) {
    var size = _a.size, position = _a.position, children = _a.children, props = __rest(_a, ["size", "position", "children"]);
    return (React.createElement(Container, __assign({ "$size": size, "$position": position }, props), children));
};
export default Main;
/*==================== Types ====================*/
var sizes = {
    default: "default",
    large: "large",
    form: "form,",
};
var positions = { 1: 1, 2: 2 };
/*==================== Styles ====================*/
var Container = styled.main(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", ";\n    ", ";\n    min-height: 100vh;\n    grid-column: ", ";\n\n    @media ", " {\n        min-height: inherit;\n        grid-column: 2;\n    }\n\n    & > div,\n    & > h1,\n    & > h2,\n    & > h3,\n    & > h4,\n    & > h5,\n    & > h6,\n    & > p,\n    & > ul,\n    & > ol,\n    & > dl,\n    & > section,\n    & > input,\n    & > article,\n    & > hr,\n    & > pre,\n    & > table,\n    & > header,\n    & > footer,\n    & > iframe,\n    & > nav,\n    & > noscript,\n    & > picture,\n    & > select,\n    & > textarea,\n    & > form {\n        justify-self: stretch;\n    }\n"], ["\n    width: ", ";\n    ", ";\n    min-height: 100vh;\n    grid-column: ", ";\n\n    @media ", " {\n        min-height: inherit;\n        grid-column: 2;\n    }\n\n    & > div,\n    & > h1,\n    & > h2,\n    & > h3,\n    & > h4,\n    & > h5,\n    & > h6,\n    & > p,\n    & > ul,\n    & > ol,\n    & > dl,\n    & > section,\n    & > input,\n    & > article,\n    & > hr,\n    & > pre,\n    & > table,\n    & > header,\n    & > footer,\n    & > iframe,\n    & > nav,\n    & > noscript,\n    & > picture,\n    & > select,\n    & > textarea,\n    & > form {\n        justify-self: stretch;\n    }\n"])), function (_a) {
    var $size = _a.$size;
    return $size === "large"
        ? Variables.Layouts.Main.Large
        : $size === "form"
            ? Variables.Layouts.Main.Form
            : Variables.Layouts.Main.Default;
}, Mixins.Grid({
    $alignContent: "start",
    $justifyItems: "start",
    $gap: "l",
    $padding: "".concat(Variables.Spacers.XXL, " 0"),
}), function (_a) {
    var $position = _a.$position;
    return ($position === 2 ? 3 : 2);
}, Variables.Breakpoints.Tablet);
var templateObject_1;
